/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} General action types.
 */

export const SET_LOADING = "[ADMIN_GENERAL] SET_LOADING";
export const SET_LOCATION_LIST = "[ADMIN_GENERAL] SET_LOCATION_LIST";
export const SET_ARTIST_EXPERIENCE_CATEGORY_LIST =
  "[ADMIN_GENERAL] SET_ARTIST_EXPERIENCE_CATEGORY_LIST";
export const SET_RECRUITER_EXPERIENCE_CATEGORY_LIST =
  "[ADMIN_GENERAL] SET_RECRUITER_EXPERIENCE_CATEGORY_LIST";
export const SET_REPORT_TYPE_LIST = "[ADMIN_GENERAL] SET_REPORT_TYPE_LIST";
export const SET_EXPERIENCE_TYPE_LIST = "[ADMIN_GENERAL] SET_EXPERIENCE_TYPE_LIST";
